import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { verifiedPnlText } from '@/services/forexApi';

interface AccountSummaryCardProps {
  runningFollows: number | null;
  pausedFollows: number | null;
  connectedAccounts: number | null;
  pendingAlerts: number | null;
  recentDecisions: number | null;
  weekPnl?: number | null;
  pnlCurrency?: string | null;
}

export default function AccountSummaryCard({
  runningFollows = 0,
  pausedFollows = 0,
  connectedAccounts = 0,
  pendingAlerts = 0,
  weekPnl = null,
  pnlCurrency = null,
}: AccountSummaryCardProps) {
  const navigate = useNavigate();
  const [hideBalance, setHideBalance] = useState(false);

  // ── 跟单概览四大指标 ──
  const overviewCards = [
    { label: '运行中', count: runningFollows, unit: '个', icon: 'ri-play-circle-line', color: '#10B981', bg: '#ECFDF5' },
    { label: '已暂停', count: pausedFollows, unit: '个', icon: 'ri-pause-circle-line', color: '#F59E0B', bg: '#FFFBEB' },
    { label: '已连接', count: connectedAccounts, unit: '账户', icon: 'ri-link-m', color: '#6366F1', bg: '#EEF2FF' },
    { label: '未读消息', count: pendingAlerts, unit: '条', icon: 'ri-notification-3-line', color: '#EF4444', bg: '#FFF1F2' },
  ];



  return (
    <div className="px-5 mt-4 relative z-10">
      <div
        className="bg-white rounded-2xl px-4 pt-3.5 pb-4"
        style={{
          boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
          border: '1px solid rgba(0,0,0,0.03)',
        }}
      >
        {/* Header row */}
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center gap-2">
            <span className="text-gray-900 font-semibold text-[15px]">跟单概览</span>

          </div>
          <button
            onClick={() => navigate('/assets')}
            className="flex items-center gap-0.5 text-gray-500 text-xs"
          >
            <span>表现详情</span>
            <i className="ri-arrow-right-s-line text-sm" />
          </button>
        </div>

        {/* Four overview metrics grid */}
        <div className="grid grid-cols-4 gap-2 mb-4">
          {overviewCards.map((card) => (
            <div key={card.label} className="flex flex-col items-center text-center">
              <div
                className="w-9 h-9 flex items-center justify-center rounded-xl mb-1.5"
                style={{ background: card.bg }}
              >
                <i className={`${card.icon} text-sm`} style={{ color: card.color }} />
              </div>
              <span className="font-bold text-lg leading-tight" style={{ color: card.color }}>
                {card.count ?? '—'}
              </span>
              <span className="text-gray-500 text-[10px] mt-0.5 leading-tight">{card.label}</span>
            </div>
          ))}
        </div>

        {/* ── 跟单表现参考（弱展示）── */}
        <div className="pt-3 border-t border-gray-50">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5">
              <span className="text-gray-400 text-[11px]">近 180 天已实现盈亏</span>
              <button
                onClick={() => setHideBalance(!hideBalance)}
                className="w-4 h-4 flex items-center justify-center"
              >
                <i
                  className={`${hideBalance ? 'ri-eye-off-line' : 'ri-eye-line'} text-gray-300 text-xs`}
                />
              </button>
            </div>
            <span
              className={`text-sm font-semibold ${weekPnl == null || !pnlCurrency ? 'text-gray-400' : weekPnl >= 0 ? 'text-green-500' : 'text-red-500'}`}
            >
              {hideBalance ? '****' : verifiedPnlText(weekPnl, pnlCurrency)}
            </span>
          </div>
          <p className="text-gray-400 text-[10px] mt-0.5 leading-relaxed">
            {weekPnl == null || !pnlCurrency ? '平仓盈亏待核对' : '以已核对平仓记录计算'} · 历史表现不预示未来结果
          </p>
        </div>
      </div>
    </div>
  );
}
